<script>
  import dayjs from 'dayjs'

	export default {
    name: "movieCard",

		data () {
			return {
				currentTimeStamp: null,
			}
		},

		props: {
			nowShowing: Boolean,
			comingSoon: Boolean,
			content: Object,
			hideCaption: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			classes() {
				return {
					'movie-thumbnail': true,
					'movie-thumbnail__now-showing': this.nowShowing,
					'movie-thumbnail__coming-soon': this.comingSoon
				}
			},
		},

	    methods: {
			getFormattedDate(timestamp) {
				return dayjs.unix(timestamp).format('D MMMM');
			}
	    },

		created() {
			console.log()
      		this.currentTimeStamp = dayjs().unix();
		}
	}
</script>

<template>
	<div :class="classes" v-if="(typeof content === 'object') && content.poster != undefined && content.poster != null">
		<div>
			<div class="movie-thumbnail__img">
				<img :src="content.poster.url" :alt="content.poster.alt">
				<span class="label label--invert" v-if="content.rating">{{content.rating}}</span>
			</div>
			<div class="movie-thumbnail__caption" v-if="!hideCaption">
				<slot name="caption">
					<div v-if="content.date > currentTimeStamp && content.has_sessions_available" style="width:95%; padding:5px; margin:10px auto 3px; background-color:#007cbd; color: #ffffff; text-align: center;">PRE-BOOK NOW</div>
					<template v-if="content.date > currentTimeStamp">
						<span class="caption__release">
							Releases {{ getFormattedDate(content.date) }}
						</span>
					</template>

					<h5 class="movie-thumbnail__title">{{content.title}}</h5>

					<ul class="movie-thumbnail__subtitle">
					  <li v-for="genre in content.genres">
              <template v-if="genre.name">
                {{genre.name.toLowerCase()}}
              </template>
              <template v-else>
                {{genre.toLowerCase()}}
              </template>
            </li>
					</ul>

				</slot>
			</div>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// movieCard.vue?48c2aee1